module.exports = __webpack_public_path__ + "static/img/Josh_Kelly_desktop.6dfc0c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh_Kelly_desktop.jpg
// module id = Z3Zk
// module chunks = 0